<template>
  <Component
    :is="tag"
    :class="[ computedClasses, ...c_font ]"
    :style="computedStyles"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>
      {{ text }}
    </slot>
  </Component>
</template>

<script>
// font
import Typography from './typography'
import { createBreakpointValidator } from '@/util/helpers/createBreakpointValidator'

const typographyValidator = createBreakpointValidator(Typography)

export default {
  name: 'UiText',
  props: {
    text: { type: [String, Number] },
    color: { type: String, default: null }, // Example: typography-body01
    bold: { type: Boolean },
    tag: { type: String, default: 'div' },
    font: {
      type: [String, Object],
      default: '',
      validator: typographyValidator,
    },
    alignCenter: { type: Boolean },
    upperCase: { type: Boolean },
    noWrap: { type: Boolean },
    type: { type: undefined, validator: (v) => {
      if (v !== undefined) {
        console.warn('UiText type should be undefined, got: ', v)
      }
      return true
    } }, // remove later
  },
  computed: {
    c_font() {
      if (typeof this.font === 'string') {
        return [`${this.font}`]
      }

      // Otherwise, size is an object:
      // e.g. { default: 's', desktop-mid: 'm', ... }
      const classes = []
      // Always add the default size class
      if (this.font.default) {
        classes.push(`${this.font.default}`)
      }

      // For each breakpoint key (like 'desktop-mid'),
      // create a special "responsive-size-{breakpoint}-{value}" class
      for (const [bp, val] of Object.entries(this.font)) {
        if (bp === 'default') continue
        classes.push(`responsive-font-${bp}-${val}`)
      }

      return classes
    },
    computedClasses() {
      return {
        'font-bold': this.bold,
        'align-center': this.alignCenter,
        'uppercase': this.upperCase,
        'no-wrap': this.noWrap,
      }
    },
    computedStyles() {
      const styles = {}
      if (this.color) {
        styles.color = `var(--${this.color})`
      }
      return styles
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
